import usePartner from './usePartner'
import useHasDisplayPromo from './useHasDisplayPromo'

function usePartnerPromo(promoContentKey, fallbackKey = null, promoNames = []) {
  const promoContent = usePartner(promoContentKey)
  const fallbackContent = fallbackKey ? usePartner(fallbackKey) : null
  const hasDisplayPromo = useHasDisplayPromo(promoNames)

  if (!promoContent || !hasDisplayPromo) {
    return fallbackContent
  }

  return promoContent
}

export default usePartnerPromo
